module.exports = {
  back: 'กลับ',
};
